import React from 'react';

import Container from '../../../Container/Container';

import RMFEKYCSuccessPrompt from './components/RMFEKYCSuccessPrompt';

const RMFEKYCSuccess: React.FC = () => (
  <Container
    page={RMFEKYCSuccess}
    headerProps={{
      title: 'fullName',
      buttons: { back: false }
    }}
  >
    <RMFEKYCSuccessPrompt />
  </Container>
);

RMFEKYCSuccess.displayName = 'RMFEKYCSuccess';

export default RMFEKYCSuccess;
